import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import { getClusterBoundaryGeoJson } from '@/lib/map/eastern-galilee';

const OUTLINE_STYLE: L.PathOptions = {
  color: '#2f6b45',
  weight: 2,
  opacity: 0.35,
  fillColor: '#2f6b45',
  fillOpacity: 0.04,
  interactive: false,
};

export default function ClusterBoundaryLayer() {
  const map = useMap();
  const layerRef = useRef<L.GeoJSON | null>(null);

  useEffect(() => {
    const geojson = getClusterBoundaryGeoJson();
    const layer = L.geoJSON(geojson as GeoJSON.GeoJsonObject, {
      style: OUTLINE_STYLE,
    });
    layer.addTo(map);
    layerRef.current = layer;
    return () => {
      if (layerRef.current) {
        try {
          map.removeLayer(layerRef.current);
        } catch {
          // Map may already be destroyed during test teardown.
        }
        layerRef.current = null;
      }
    };
  }, [map]);

  return null;
}
